<template>
<b-modal id="confirm-duplicate-modal" title="WARNING" ok-title="Confirm" @ok="confirmDuplicate">
  <p>The email address <strong>{{registration.email}}</strong> is already associated to a registered
    <a href="https://sso.ia2.inaf.it/rap-ia2" target="_blank">RAP</a> account.
  </p>
  <p>Usually people don't need multiple accounts but <strong>if you are sure</strong>
    you can proceed by clicking on the confirm button.</p>
</b-modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: mapState({
    registration: state => state.registration
  }),
  methods: {
    confirmDuplicate() {
      this.$store.dispatch('confirmDuplicate');
    }
  }
};
</script>
